import { Drawer } from "ant-design-vue";
const { ...other } = Drawer;
const YwDrawer = {
	...other,
	name: "YwDrawer",
};

YwDrawer.install = function (Vue) {
	Vue.component(YwDrawer.name, YwDrawer);
};

export default YwDrawer;
